module.exports = __webpack_public_path__ + "static/media/junit.3ab4f3f1.png";